import { profileStrings as strings } from '@/constants/residents/strings';

export type MenuItem =
  | { key: 'connections'; type: 'connections' }
  | { key: 'profile' | 'password' | 'paymentMethods' | 'autopay' | 'wifi' | 'feedback' | 'roommates' | 'howItWorks' | 'tutorial' | 'deleteAccount'; type: 'action'; title: string; };

export function buildProfileMenu(isWifiEnabled: boolean, shouldShowPayments: boolean): MenuItem[] {
  const items: MenuItem[] = [
    { key: 'connections', type: 'connections' },
    { key: 'profile', type: 'action', title: strings.option.profile },
    { key: 'password', type: 'action', title: strings.option.password },
    ...(shouldShowPayments ? [
      { key: 'paymentMethods', type: 'action', title: 'Payment Methods' } as MenuItem,
      { key: 'autopay', type: 'action', title: 'Autopay' } as MenuItem,
    ] : []),
    ...(isWifiEnabled ? [{ key: 'wifi', type: 'action', title: strings.option.wifi } as MenuItem] : []),
    { key: 'roommates', type: 'action', title: strings.option.roommates },
    { key: 'howItWorks', type: 'action', title: strings.option.howItWorks },
    { key: 'tutorial', type: 'action', title: strings.option.tutorial },
    { key: 'feedback', type: 'action', title: strings.option.feedback },
    { key: 'deleteAccount', type: 'action', title: strings.option.deleteAccount },
  ];
  return items;
}

export const accessibilityKeyMap: Record<string, string> = {
  connections: 'profile.option.connections',
  profile: 'profile.option.profile',
  password: 'profile.option.password',
  paymentMethods: 'profile.option.payment_methods',
  autopay: 'profile.option.autopay',
  wifi: 'profile.option.wifi',
  roommates: 'profile.option.roommates',
  howItWorks: 'profile.option.how_it_works',
  tutorial: 'profile.option.tutorial',
  feedback: 'profile.option.feedback',
  deleteAccount: 'profile.option.delete.account',
};


